export const iconFontAwesomeTravelHotelHorse = (
	<i className="fa-solid fa-horse"></i>
);
